import {FormControl, FormGroup} from '@angular/forms';
import {Component, EventEmitter, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MatPaginator, MatSort, MatTableDataSource} from '@angular/material';
import {merge} from 'rxjs/observable/merge';
import {of as observableOf} from 'rxjs/observable/of';
import {catchError} from 'rxjs/operators/catchError';
import {map} from 'rxjs/operators/map';
import {startWith} from 'rxjs/operators/startWith';
import {switchMap} from 'rxjs/operators/switchMap';
import {MatDialog} from '@angular/material';
import {ManufacturerDialogComponent} from '@app/app/manufacturers/manufacturer.dialog.component';
import {UrlHelper} from '@app/app/shared/helpers/url.helper';
import {Subscription} from 'rxjs/Subscription';

@Component({
  moduleId: module.id,
  selector: 'manufacturers',
  styleUrls: ['manufacturers.css'],
  templateUrl: 'manufacturers.component.html'
})

export class ManufacturersComponent implements OnInit, OnDestroy {
  displayedColumns = ['id', 'first_name', 'last_name', 'email', 'phone', 'created', 'actions'];
  dataSource = new MatTableDataSource();

  resultsLength = 0;
  isLoadingResults = true;

  filterForm = new FormGroup({
    query: new FormControl(),
    active: new FormControl(),
  });

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  filter = new Filter();
  sub1: Subscription;
  sub2: Subscription;

  ngOnDestroy() {
    if (this.sub1) {
      this.sub1.unsubscribe();
    }

    if (this.sub2) {
      this.sub2.unsubscribe();
    }
  }

  constructor(private http: HttpClient, public dialog: MatDialog, private urlHelper: UrlHelper) {
    //
  }

  applyFilter(filterValue: string) {
    this.filter.change(filterValue);
  }

  private prepareUrl(): string {
    let sortField = '';

    if ((this.sort.direction === 'asc' || this.sort.direction === 'desc') && this.sort.active) {
      if (this.sort.direction === 'desc') {
        sortField = '-' + this.sort.active;
      } else if (this.sort.direction === 'asc') {
        sortField = this.sort.active;
      }
    }

    const page = this.paginator.pageIndex + 1 || 1;
    const query = this.filter.filterValue || '';
    const active = this.filter.activeValue || '';

    return `/manufacturers?filter[query]=${query}&page=${page}&sort=${sortField}&filter[active]=${active}`;
  }

  clear() {
    this.filter.reset();
    this.filterForm.patchValue({
      query: null,
      active: null
    });
  }

  toggleActive(value) {
    this.filter.changeA(value);
  }

  ngOnInit() {
    // If the user changes the sort order, reset back to the first page.
    this.sub1 = this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    this.sub2 = merge(this.filter.filterApplied, this.sort.sortChange, this.paginator.page).pipe(
      startWith({}),
      switchMap(() => {
        this.isLoadingResults = true;
        return this.http.get<any>(this.prepareUrl());
      }),
      map(data => {
        // Flip flag to show that loading has finished.
        this.isLoadingResults = false;
        this.resultsLength = data.meta.pagination.total;

        return data.data;
      }),
      catchError(() => {
        this.isLoadingResults = false;
        return observableOf([]);
      })
    ).subscribe(data => {
      this.dataSource.data = data;
    });

    this.dataSource.sort = this.sort;
  }

  openDialog(user = null): void {
    const dialogRef = this.dialog.open(ManufacturerDialogComponent, {
      width: '400px',
      data: {user: user}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (typeof result !== 'undefined' && result === 'Confirm') {
        this.reloadData();
      }
    });
  }

  deleteUserItem(user) {
    if (confirm(`Are you sure want to delete ${user.attributes.first_name} ${user.attributes.last_name}?`)) {
      this.http.delete(`/manufacturers/${user.id}`).subscribe(res => {
        this.reloadData();
      });
    }
  }

  reloadData() {
    this.isLoadingResults = true;

    return this.http.get<any>(this.prepareUrl()).subscribe(data => {
      this.isLoadingResults = false;
      this.resultsLength = data.meta.pagination.total;
      this.dataSource.data = data.data;
    });
  }
}

export class Filter {
  filterApplied = new EventEmitter();
  filterValue = '';
  activeValue = '';

  reset() {
    this.filterValue = '';
    this.activeValue = '';
    this.filterApplied.emit();
  }

  change(val: string) {
    this.filterValue = val;
    this.filterApplied.emit();
  }

  changeA(val: string) {
    this.activeValue = val;
    this.filterApplied.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/manufacturers/manufacturers.component.ts